"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils/utils");

var _UIAvatar = _interopRequireDefault(require("ui-addon-avatars/UIAvatar"));

var _UISimpleAvatar = _interopRequireDefault(require("ui-addon-avatars/UISimpleAvatar"));

var _UIUnauthedHubSpotUserAvatar = _interopRequireDefault(require("ui-addon-avatars/UIUnauthedHubSpotUserAvatar"));

var _UIMediaObject = _interopRequireDefault(require("UIComponents/layout/UIMediaObject"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var AVATAR_SIZE = 'md';

var ReviewerInfo =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ReviewerInfo, _PureComponent);

  function ReviewerInfo() {
    (0, _classCallCheck2.default)(this, ReviewerInfo);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReviewerInfo).apply(this, arguments));
  }

  (0, _createClass2.default)(ReviewerInfo, [{
    key: "renderAvatar",
    value: function renderAvatar(userAvatarUrl, userEmail, isCustomer) {
      if (userAvatarUrl) {
        return _react.default.createElement(_UISimpleAvatar.default, {
          size: AVATAR_SIZE,
          src: userAvatarUrl
        });
      }

      if (isCustomer) {
        return _react.default.createElement(_UIAvatar.default, {
          lookup: {
            type: 'hubSpotUserEmail',
            primaryIdentifier: userEmail
          },
          size: AVATAR_SIZE
        });
      }

      return _react.default.createElement(_UIUnauthedHubSpotUserAvatar.default, {
        email: userEmail,
        size: AVATAR_SIZE
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          company = _this$props.company,
          isCustomer = _this$props.isCustomer,
          userAvatarUrl = _this$props.userAvatarUrl,
          userEmail = _this$props.userEmail,
          userFullName = _this$props.userFullName;
      return _react.default.createElement(_UIMediaObject.default, {
        align: "center",
        itemLeft: this.renderAvatar(userAvatarUrl, userEmail, isCustomer)
      }, _react.default.createElement("p", {
        className: "m-bottom-0"
      }, userFullName), company && _react.default.createElement(_Small.default, {
        className: "m-bottom-0 m-top-1 secondary-text",
        tagName: "p"
      }, company));
    }
  }]);
  return ReviewerInfo;
}(_react.PureComponent);

ReviewerInfo.propTypes = {
  company: _propTypes.default.string,
  isCustomer: _propTypes.default.bool.isRequired,
  userAvatarUrl: _propTypes.default.string,
  userEmail: _propTypes.default.string,
  userFullName: _propTypes.default.string.isRequired
};

function mapStateToProps(state) {
  return {
    isCustomer: (0, _utils.isCustomer)(state.auth.portal)
  };
}

var mapDispatchToProps = {};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReviewerInfo);

exports.default = _default;
module.exports = exports.default;